import { render, staticRenderFns } from "./ProjectItemTechs.vue?vue&type=template&id=473176a8&scoped=true&"
import script from "./ProjectItemTechs.vue?vue&type=script&lang=js&"
export * from "./ProjectItemTechs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectItemTechs.vue?vue&type=style&index=0&id=473176a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473176a8",
  null
  
)

export default component.exports